import * as React from "react";
import "./styles.scss";
import {COLOR} from "utils/variables";
import {useEffect, useRef} from "react";
import { useLocation, useHistory } from "react-router-dom";

interface IListOptions {
    name: string;
    value: string | number;
}

interface IProps {
    label?: string;
    onChange: (value: string | number) => void;
    onSelect: (name: string, value: string | number) => void;
    value: string | number;
    fieldName: string;
    list: IListOptions[];
    placeholder?: string;
    onClose: () => void;
    isAndroid?: boolean;
    showSearchInput: boolean;
}

const SearchInput = (props: IProps) => {
    const inputRef = useRef(null);
    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const getSearchInput = searchParams.get("searchInput");
    const setSearchInput = React.useCallback(
        (value: boolean) => {
          searchParams.set("searchInput", value.toString());
        },
        [searchParams],
    );
    const toggleSearch = React.useCallback(
      (value: boolean) => {
        setSearchInput(value);
        history.push({search: searchParams.toString()});
      }, [setSearchInput, history, searchParams],
    );
    useEffect(() => {
        inputRef.current.focus();
        if (props.showSearchInput) {
          toggleSearch(true);
        }
        history.listen(location => {
          if (history.action === 'POP') {
            props.onClose();
          }
        })
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [props.showSearchInput]);
    const containerStyle = {
        left: props.isAndroid || window.screen.width < 451 ? 0 : "25%",
        right: props.isAndroid || window.screen.width < 451 ? 0 : "25%",
        top: props.isAndroid ? 0 : "12%",
        borderRadius: 5,
        padding: 5,
        boxShadow: `-1px 1px 5px 0px ${COLOR.GRAY}`,
    };
    const inputStyle = {
        width: "100%",
        border: `1px solid ${COLOR.GRAY}`,
        height: 40,
        borderRadius: 3,
        padding: 5,
        fontSize: 14,
    };
    const listStyle = {
        backgroundColor: COLOR.WHITE,
        height: props.isAndroid ? "calc(100vh - 107px)" : "calc(100vh - 250px)",
    };
    const labelStyle = {
        fontSize: 15,
        padding: "5px 0",
        color: COLOR.BLACK,
        marginTop: 20,
        fontWeight: 600,
    };
    const listItemStyle = {
        padding: "7px",
        fontSize: "15px",
        cursor: "pointer",
        borderBottom: `1px solid ${COLOR.GRAY}`,
    };
    const handleOnSelectItem = (item) => {
      props.onSelect(item.name, item.value);
      history.goBack();
    }
    const handleOnClose = () => {
      props.onClose();
      history.goBack();
    }
    return(
        <div className="component-container">
        <div className="search-input-container" style={containerStyle}>
            <div className="cross-icon">
                <span onClick={() => handleOnClose()}>&#10005;</span>
            </div>
            <div className="input">
                {
                    props.label &&
                    <div style={labelStyle}>
                        {props.label}
                    </div>
                }
                <input
                    ref={inputRef}
                    onChange={(e) => props.onChange(e.target.value)}
                    placeholder={props.placeholder}
                    value={props.value}
                    name={props.fieldName}
                    style={inputStyle}
                />
            </div>
            <div className="list-container"
                 style={listStyle}
            >
                <div>
                    {
                        props.list.length > 0 && props.list.map((item, index) => {
                            return(
                                <div
                                    key={index}
                                    onClick={() => handleOnSelectItem(item)}
                                    style={listItemStyle}
                                >
                                    {item.name}
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
        </div>
    );
};

export default SearchInput;
